import { createContext, useState } from "react";

export const SystemAdministratorContext = createContext();
const SystemAdministratorProvider = ({children}) =>{
    const [showCreateNewSystemAdministratorWindow,setShowCreateNewSystemAdministratorWindow] = useState(false);
    const [systemAdministrators,setSystemAdministrators] = useState(null);
    const [reloadSystemAdministrators,setReloadSystemAdministrators] = useState(false);
    const [selectedSystemAdministrator,setSelectedSystemAdministrator] = useState(null);
    const [selectedToEditSystemAdministrator,setSelectedToEditSystemAdministrator] = useState(null);
    const [selectedToDeleteSystemAdministrator,setSelectedToDeleteSystemAdministrator] = useState(null);
    return(
        <SystemAdministratorContext.Provider value={{
            showCreateNewSystemAdministratorWindow,setShowCreateNewSystemAdministratorWindow,
            systemAdministrators,setSystemAdministrators,
            reloadSystemAdministrators,setReloadSystemAdministrators,
            selectedSystemAdministrator,setSelectedSystemAdministrator,
            selectedToEditSystemAdministrator,setSelectedToEditSystemAdministrator,
            selectedToDeleteSystemAdministrator,setSelectedToDeleteSystemAdministrator
        }}>{children}</SystemAdministratorContext.Provider>
    );
};
export default SystemAdministratorProvider;